import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ManagementPartTimeEmployee } from '../models/models';

import { InfrastructureService } from './infrastructure.service';

@Injectable({
  providedIn: 'root',
})
export class ManagementPartTimeEmployeeService extends InfrastructureService<ManagementPartTimeEmployee> {
  protected readonly endpoint: string = '/ManagementPartTimeEmployees';

  constructor(protected http: HttpClient) {
    super(http);
  }

}
